module.exports = "/virtual-football/img/video/virtualf-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/virtualf-logo.png
// module id = 1985
// module chunks = 6